import { postApiCall} from "../utils/Api";

export const ListSales = async (data) => {
    try {
      //console.log(data);
      const result = await postApiCall(`/api/v1/dashboard/getlocationwisesales`,data,true);
      var apiresult = JSON.parse(result.data.message);
      return apiresult;
    } catch (e) {
      throw e;
    }
  };